function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import * as React from "react";
import { useId } from "@react-aria/utils";
import { cx } from "../../helpers/utils/cx";
export const RadioGroupContext = /*#__PURE__*/React.createContext(null);
function RadioGroup(props, ref) {
  const {
    name,
    value,
    defaultValue,
    disabled,
    error = false,
    label,
    "aria-labelledby": ariaLabelledBy,
    onChange,
    required = false,
    renderHelperText = renderHelperTextDefault,
    row = false,
    children,
    helperText: _helperText
  } = props;
  const generatedId = useId();
  const localLabelId = `${generatedId}-label`;
  const helperTextId = `${generatedId}-helptext`;
  const labelId = ariaLabelledBy ?? localLabelId;
  const contextValues = React.useMemo(() => ({
    name,
    value,
    defaultValue,
    disabled,
    onChange,
    required,
    error
  }), [name, value, defaultValue, disabled, onChange, required, error]);
  return /*#__PURE__*/React.createElement(RadioGroupContext.Provider, {
    value: contextValues
  }, /*#__PURE__*/React.createElement("div", {
    "aria-invalid": error,
    "aria-labelledby": labelId,
    "aria-orientation": row ? "horizontal" : "vertical",
    role: "radiogroup",
    className: cx("flex gap-3 flex-col"),
    ref: ref
  }, label && /*#__PURE__*/React.createElement("span", {
    className: cx("bolt-font-body-s-accent text-primary", required && "after:text-danger-primary after:content-['_*']"),
    id: labelId
  }, label), /*#__PURE__*/React.createElement("div", {
    className: cx("flex gap-3", row ? "flex-row" : "flex-col items-start")
  }, children), renderHelperText(_objectSpread(_objectSpread({}, props), {}, {
    helperTextId
  }), renderHelperTextDefault)));
}
function renderHelperTextDefault(_ref) {
  let {
    helperText,
    error,
    helperTextId,
    disabled
  } = _ref;
  if (!helperText) {
    return null;
  }
  return /*#__PURE__*/React.createElement("p", {
    className: cx("m-0 bolt-font-body-s-regular text-secondary", disabled && "text-tertiary", error && "text-danger-primary"),
    id: helperTextId
  }, helperText);
}
const forwardedRadioGroup = /*#__PURE__*/React.forwardRef(RadioGroup);
export { forwardedRadioGroup as RadioGroup };